export const ButtonOptionsFormFieldGroupProp = Object.freeze({
    Title: 'title',
    GroupName: 'groupName',
    ButtonOptionFields: 'buttonOptionFields',
    PositionNumber: 'positionNumber',
});